import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/InventoryListPage.css';
import { FaEye, FaEdit } from 'react-icons/fa';

const StockBranchListPage = () => {
    const [branchList, setBranchList] = useState([]);
    const [inventories, setInventories] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);

    // Fetch branch list when component mounts
    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);
            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };

        fetchBranchList();
        
    }, []);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); 
        }
    }, [currentPage, isSearched]);

    const handleSearch = async () => {
        try {
            const response = await api.post('/inventory/getInventoryBranchList', {
                data: [{
                    item_name: searchName,
                    item_type: selectedType,
                    branch_id: selectedBranch,
                }],
                limit: 25, 
                page: currentPage 
            });
            setInventories(response.data.data.inventoryList);
            setTotalData(response.data.data.totalCount); 
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); 

            const totalCount = response.data.data.totalCount;
            
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / 25));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch inventories", error);
        }
    };
    

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleViewDetails = (inventoryBranchId) => {
        console.log("Navigating to details for ID:", inventoryBranchId); 
        navigate(`/inventory/branchDetail/${inventoryBranchId}`);
    };

    return (
        <div className="inventory-page">           
            <div className="page-title">Stock Branch List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter item name"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Type</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedType}
                                            onChange={(e) => setSelectedType(e.target.value)}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="BOOK">BOOK</option>
                                            <option value="OTHERS">OTHERS</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Branch</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedBranch}
                                            onChange={(e) => setSelectedBranch(e.target.value)}
                                        >
                                            <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="inventory-list">
                        <table>
                            <thead>
                                <tr>
                                    <th className="no-column">No</th>
                                    <th>Item Name</th>
                                    <th>Item Type</th>
                                    <th>Stock</th>
                                    <th>Branch</th>
                                    <th>Price</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inventories.map((inventory, index) => (
                                    <tr key={inventory.inventory_branch_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                        <td>{inventory.Inventory.item_name}</td>
                                        <td>{inventory.Inventory.item_type}</td>
                                        <td>{inventory.total_stock}</td>
                                        <td>{inventory.Branch ? inventory.Branch.branch_name : ""}</td>
                                        <td>{inventory.price}</td>
                                        <td>
                                            <FaEye className="action-icon" title="View Details" onClick={() => handleViewDetails(inventory.inventory_branch_id)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StockBranchListPage;
